export default __webpack_public_path__ + "static/examp8-a171ccffc47cd496f45809bf1997757e.gif";